export default __webpack_public_path__ + "static/media/HeroBackground@sm.cb5a4b41.jpg";